import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import type { PermissionKey } from '@fenix/shared';
import { Button } from '@/components/ui/button';
import { useAuthStore, useCan } from './store';

export function ForbiddenPage() {
  return (
    <div className="flex h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-muted">
        <ShieldOff className="size-7 text-muted-foreground" />
      </div>
      <div>
        <p className="text-lg font-semibold">Sem permissão</p>
        <p className="text-sm text-muted-foreground">
          Seu perfil não tem acesso a esta área. Fale com um administrador.
        </p>
      </div>
      <Button asChild variant="outline">
        <Link to="/dashboard">Voltar ao painel</Link>
      </Button>
    </div>
  );
}

/** Esconde uma rota de quem não tem a permissão. A API valida de novo em cada chamada. */
export function RequirePermission({
  permission,
  children,
}: {
  permission: PermissionKey;
  children: ReactNode;
}) {
  const allowed = useCan(permission);
  return allowed ? <>{children}</> : <ForbiddenPage />;
}

/** Rota exclusiva do Super Administrador (fora do catálogo de permissões). */
export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const role = useAuthStore((s) => s.user?.role);
  return role === 'super_admin' ? <>{children}</> : <ForbiddenPage />;
}
